<template>
  <b-modal
    id="awaitTillDateModal"
    ref="awaitTillDateModal"
    :title="`${processName} - ${$t('DEBTIA_AWAIT_TILL_DATE_MODAL_TITLE')}`"
    :ok-title="$t('DEBTIA_SUBMIT')"
    :cancel-title="$t('DEBTIA_CANCEL')"
    cancel-variant="outline-secondary"
    centered
    no-close-on-backdrop
    :size="'md'"
    :busy="loaderModal"
    @show="resetModal"
    @hidden="resetModal"
    @ok="submitHandler"
  >
    <b-overlay
      id="overlay-background"
      :show="loaderModal"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-alert
        v-if="awaitTillDateError"
        variant="warning"
        show
      >
        <div class="alert-body">
          <span v-if="awaitTillDateError">{{ awaitTillDateError }}</span>
        </div>
      </b-alert>
      <b-row>
        <b-col cols="12">
          <b-alert
            v-if="question"
            show
            variant="secondary"
            style="border-left: 4px solid #3b82f6 !important; background-color: #2d2d2d;"
          >
            <div class="alert-body">
              <p
                class="m-0"
                style="font-weight: 400; font-size: 0.95rem; line-height: 1.5; word-break: break-word;"
              >
                {{ question }}
              </p>
            </div>
          </b-alert>
          <validation-observer
            ref="awaitTillDateRules"
            tag="form"
          >
            <validation-provider
              #default="{ errors }"
              name="awaitTill Date"
              :rules="getRules(dateOption)"
            >
              <b-form-group
                :label="$t('DEBTIA_AWAIT_TILL_DATE_MODAL_TITLE')"
                label-for="awaitTillDate"
                :state="errors ? false : null"
              >
                <b-input-group>
                  <cleave
                    v-model="daAwaitTillDate"
                    class="form-control"
                    :raw="false"
                    :options="options.date"
                    placeholder="DD-MM-YYYY"
                    :class="errors.length > 0 ? 'is-invalid' : ''"
                    @input="validateDate(0, daAwaitTillDate)"
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="awaitTillDate"
                      :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                      :min="new Date()"
                      button-only
                      right
                      size="sm"
                      button-variant="primary"
                      @input="validateDate(1, awaitTillDate)"
                    />
                  </b-input-group-append>
                </b-input-group>
                <b-form-invalid-feedback :state="errors ? false : null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </validation-observer>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BOverlay,
  BAlert,
  BRow,
  BCol,
  BFormGroup,
  BFormDatepicker,
  BModal,
  BInputGroup,
  BInputGroupAppend,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import axios from '@axios'
import { EventBus } from '@/event-bus'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'AwaitTillDateModal',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BOverlay,
    BAlert,
    BFormDatepicker,
    BModal,
    BInputGroup,
    BInputGroupAppend,
    BFormInvalidFeedback,
    Cleave,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    question: {
      type: String,
      default: '',
    },
    processName: {
      type: String,
      default: '',
    },
    processCaseId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      awaitTillDate: '',
      daAwaitTillDate: '',
      loaderModal: false,
      awaitTillDateError: '',
      caseId: this.$route.params.id,
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
      dateOption: '',
    }
  },
  methods: {
    validateDate(type, value) {
      this.awaitTillDateError = ''
      if (!value) {
        this.awaitTillDate = ''
        this.daAwaitTillDate = ''
        return
      }
      if (type === 0) {
        this.awaitTillDate = this.$FormformattedDate(value)
      } else {
        this.daAwaitTillDate = this.$DAformattedDate(value)
      }
    },
    getRules(option) {
      let validationRules = ''
      if (option === 1) {
        validationRules = 'required|datePattern|dateComparison'
      } else {
        validationRules = 'required|dateComparison'
      }
      return validationRules
    },

    resetModal() {
      this.awaitTillDate = ''
      this.daAwaitTillDate = ''
      this.awaitTillDateError = ''
      this.loaderModal = false
    },

    submitHandler(e) {
      e.preventDefault()
      this.$refs.awaitTillDateRules.validate().then(success => {
        if (success) {
          this.$swal({
            title: this.$t('DEBTIA_SURE'),
            text: `${this.$t('DEBTIA_SURE_SET_AWAIT_DATE')} ${this.daAwaitTillDate}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: this.$t('DEBTIA_YES_SET_IT'),
            cancelButtonText: this.$t('DEBTIA_CANCEL'),
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          }).then(result => {
            if (result.value) {
              this.saveAwaitDate()
            }
          })
        }
      })
    },

    saveAwaitDate() {
      this.loaderModal = true
      const payload = {
        case_id: this.caseId,
        execution_date: this.awaitTillDate,
        process_case_id: this.processCaseId,
      }

      axios.post('/process/case/save-await-case-date', payload)
        .then(response => {
          this.loaderModal = false
          if (response.status === 200) {
            EventBus.$emit('refreshModules')
            EventBus.$emit('refreshSecondaryProcesses')
            EventBus.$emit('refreshLogs')
            this.$refs.awaitTillDateModal.hide()
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: this.$t('DEBTIA_AWAIT_DATE_SET_SUCCESSFULLY'),
              },
            })
          }
        })
        .catch(e => {
          const errorMsg = Array.isArray(e.response.data.message)
            ? e.response.data.message[0]
            : e.response.data.message
          this.loaderModal = false
          this.awaitTillDateError = errorMsg || this.$t('DEBTIA_SOMETHING_WENT_WRONG')
        })
    },
  },
}
</script>
